import React, { Component } from "react";
import styles from "./monitoringsTaskTripsBar.module.scss";
import CarsTitleClosedBar from "../../../sections/cars/carsTitleClosedBar";
import SideBarInner from "../../../../shared/sideBarInner";
import CarsSecondSideBar from "../../../sections/secondSideBars/carsSecondSideBar";
import SideBar from "../../../sides/sideBar";
import TitleBarWrapper from "../../../../shared/titleBarWrapper";
import { NavLink } from "react-router-dom";
import FirstTitle from "../../../../shared/items/static/firstTitle";
import MonitoringsTaskTripsSearch from "./MonitoringsTaskTripsSearch";
import MonitoringsTaskTripsListWrapper from "./MonitoringsTaskTripsListWrapper";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { withAuth } from "../../../../shared/containers/containerAuth";

class MonitoringsTaskTripsBar extends Component {
  constructor(props) {
    super(props);
  }

  onClickMonitoringHandler() {
    const { monitoringTaskTrip, onGetMonitoringsTaskTrip } = this.props;

    if (monitoringTaskTrip !== null) {
      onGetMonitoringsTaskTrip(null);
    }
  }

  render() {
    const { data } = this.props;
    const isMonitorings = window.location.pathname.includes("monitorings");

    const monitoringsPermission = data.permissions.includes(54001);

    return (
      <div className={styles.sideBarsWrapper}>
        <SideBar TitleClosed={<CarsTitleClosedBar />}>
          <div className={styles.monitoringTaskTripsBar}>
            <SideBarInner>
              <TitleBarWrapper>
                <div style={{ display: "flex", position: "relative", width: "100%" }}>
                  <NavLink to={"/logistic/controlPoints"}>
                    <FirstTitle color={!isMonitorings ? "#408ad4" : null}>Логистика</FirstTitle>
                  </NavLink>
                  
                  {monitoringsPermission ? (
                    <div style={{ width: "50%", right: "0px", position: "absolute" }} onClick={this.onClickMonitoringHandler.bind(this)}>
                      <NavLink to={"/logistic/monitorings"}>
                        <FirstTitle color={isMonitorings ? "#408ad4" : null}>Мониторинг</FirstTitle>
                      </NavLink>
                    </div>
                  ) : null}
                </div>
              </TitleBarWrapper>
            </SideBarInner>

            <SideBarInner>
              <MonitoringsTaskTripsSearch />
            </SideBarInner>

            <SideBarInner>
              <MonitoringsTaskTripsListWrapper />
            </SideBarInner>
          </div>
        </SideBar>

        <CarsSecondSideBar />
      </div>
    );
  }
}

export default withAuth(withMonitoringTaskTrips(React.memo(MonitoringsTaskTripsBar)));
